const LABORATORIUM_PARAMETER_PREFIX = 'LABORATORIUM_PARAMETER_'
export const LABORATORIUM_PARAMETER = {
  LIST_REQUEST: `${LABORATORIUM_PARAMETER_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${LABORATORIUM_PARAMETER_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${LABORATORIUM_PARAMETER_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${LABORATORIUM_PARAMETER_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${LABORATORIUM_PARAMETER_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${LABORATORIUM_PARAMETER_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${LABORATORIUM_PARAMETER_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${LABORATORIUM_PARAMETER_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${LABORATORIUM_PARAMETER_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${LABORATORIUM_PARAMETER_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${LABORATORIUM_PARAMETER_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${LABORATORIUM_PARAMETER_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${LABORATORIUM_PARAMETER_PREFIX}CLEAR_NOTIFY`
}
